// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholderOwner {
  position: absolute !important;
  z-index: 999;
  border: solid 1px #333;
  background-color: #a3e8f6;
  padding-left: 2px;
  border-radius: 4px;
  display: flex;
}
.placeholderOther {
  position: absolute !important;
  z-index: 999;
  border: solid 1px #333;
  background-color: #f0f0f0;
  padding-left: 2px;
  border-radius: 4px;
  display: flex;
}
.placeholderPrint {
  position: absolute !important;
  z-index: 999;
  border: solid 1px transparent;
  background-color: #ffffff;
  padding-left: 2px;
  border-radius: 4px;
  display: flex;
}

.classWithHover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: 0.5s;
}

.classWithHover:hover {
  box-shadow: none;
  transition: 0.5s;
}

.react-pdf__Page__canvas {
  border-radius: 8px;
  border: 1px solid #eee;
}

.contentClass {
  padding: auto;
}

.wrapperClass {
  padding: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/recipient-view/pdf-editor-block/pdf-viewer/pdf-viewer.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":[".placeholderOwner {\n  position: absolute !important;\n  z-index: 999;\n  border: solid 1px #333;\n  background-color: #a3e8f6;\n  padding-left: 2px;\n  border-radius: 4px;\n  display: flex;\n}\n.placeholderOther {\n  position: absolute !important;\n  z-index: 999;\n  border: solid 1px #333;\n  background-color: #f0f0f0;\n  padding-left: 2px;\n  border-radius: 4px;\n  display: flex;\n}\n.placeholderPrint {\n  position: absolute !important;\n  z-index: 999;\n  border: solid 1px transparent;\n  background-color: #ffffff;\n  padding-left: 2px;\n  border-radius: 4px;\n  display: flex;\n}\n\n.classWithHover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  transition: 0.5s;\n}\n\n.classWithHover:hover {\n  box-shadow: none;\n  transition: 0.5s;\n}\n\n.react-pdf__Page__canvas {\n  border-radius: 8px;\n  border: 1px solid #eee;\n}\n\n.contentClass {\n  padding: auto;\n}\n\n.wrapperClass {\n  padding: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
